import orderBy from 'lodash-es/orderBy';
import { IState } from '..';
import { getBusinessAddresses } from '../businessEntity/businessEntitySelectors';
import { FilterTypes, getFilteredSalesDistricts, getFilters, ISalesProspectsFilters } from '../filters';
import { ProspectStatus } from '../lookups';
import { getStateAbbreviation } from '../lookups/lookupsSelectors';
import { IProspect } from './prospectsInterfaces';

export const getProspect = (state: IState, id: number): IProspect => state.prospects.hash[id];

export const getProspectName = (state: IState, prospectId: number): string =>
  state.prospects.hash[prospectId] ? state.prospects.hash[prospectId].name : 'Unknown';

export const getProspectsByStatusId = (state: IState, prospectStatusId: number): IProspect[] => {
  const {
    prospects: { ids, hash }
  } = state;
  const filters = getFilters<ISalesProspectsFilters>(state, FilterTypes.salesProspects);
  const sds = getFilteredSalesDistricts(state, filters);

  const filtered =
    prospectStatusId === ProspectStatus.Favorite
      ? ids
          .map<IProspect>(x => hash[x])
          .filter(
            x => x.prospectStatusId === ProspectStatus.Active && x.favoriteCount > 0 && filterProspect(x, sds, filters)
          )
      : ids
          .map<IProspect>(x => hash[x])
          .filter(x => x.prospectStatusId === prospectStatusId && filterProspect(x, sds, filters));

  const ordered = orderBy<IProspect>(filtered, filters.sortBy.split(' ')[0]);

  return filters.sortBy.includes('desc') ? ordered.reverse() : ordered;
};

function filterProspect(p: IProspect, salesDists: string[], filters: ISalesProspectsFilters): boolean {
  return (
    salesDists.includes(p.salesDistrict) &&
    (filters.lifeCycleSteps.length === 0 || filters.lifeCycleSteps.includes(p.prospectLifeCycleStepId!)) &&
    (filters.businessTypes.length === 0 || filters.businessTypes.includes(p.businessEntityTypeId!)) &&
    (filters.starRating.length === 0 || filters.starRating.includes(p.favoriteCount)) &&
    (!filters.searchTerm ||
      p.name.toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
      (!p.city || p.city.toLowerCase().includes(filters.searchTerm.toLowerCase())))
  );
}

export const getTotalItemsByStatusId = (state: IState, prospectStatusId: number): { [index: string]: number } => {
  return state.prospects.totalItems[prospectStatusId] ? state.prospects.totalItems[prospectStatusId] : {};
};

export function getProspectStateAndSalesDistrict(
  state: IState,
  prospectId: number
): { salesDistrict: string; state: string } {
  const prospect = getProspect(state, prospectId);
  const primaryAddress = getBusinessAddresses(state, prospect.businessEntityId).find(x => x.primary);
  const stateAbb = primaryAddress ? getStateAbbreviation(state, primaryAddress.stateId) : '';

  return {
    salesDistrict: prospect ? prospect.salesDistrict : '',
    state: stateAbb
  };
}
